/**
 * Pricing Component Types
 *
 * TypeScript types for pricing component management.
 * These types match the backend DTOs for seamless integration.
 */

/**
 * Pricing component list item DTO
 * Used in paginated list views
 */
export interface PricingComponentListDto {
  id: string;
  name: string;
  slug: string;
  unit: string;
  componentType: ComponentType;
  isActive: boolean;
  priceCount: number;
  createdAt: string;
}

/**
 * Pricing component detail DTO
 * Used in detail views and after create/update operations
 */
export interface PricingComponentDetailDto {
  id: string;
  name: string;
  slug: string;
  unit: string;
  description?: string;
  componentType: ComponentType;
  isActive: boolean;
  metadata?: string;
  priceCount: number;
  createdAt: string;
  updatedAt?: string;
}

/**
 * Create pricing component request DTO
 */
export interface CreatePricingComponentRequest {
  name: string;
  slug?: string;
  unit: string;
  description?: string;
  componentType: ComponentType;
  metadata?: string;
}

/**
 * Update pricing component request DTO
 */
export interface UpdatePricingComponentRequest {
  name: string;
  unit: string;
  description?: string;
  isActive: boolean;
  metadata?: string;
}

/**
 * Component type — mirrors backend WiCloud.Domain.Enums.ComponentType
 * Values: Resource, Addon, Service, Usage (stored as PascalCase strings)
 */
export const COMPONENT_TYPES = [
  "Resource",
  "Addon",
  "Service",
  "Usage",
] as const;
export type ComponentType = (typeof COMPONENT_TYPES)[number];

/**
 * Pricing component filters for list queries
 */
export interface PricingComponentFilters {
  search?: string;
  componentType?: ComponentType;
  isActive?: boolean;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
  page?: number;
  limit?: number;
}
